import apiClient from '../api/apiClient';

const ENDPOINT = '/api/v1/pricing/resolve';

/**
 * Resolve pricing slabs for a given product, partner, and investor.
 *
 * @param {object} opts
 * @param {string} opts.productId   - Pre-IPO product UUID
 * @param {string} opts.partnerId   - Partner UUID
 * @param {string} opts.userId      - Investor (user) UUID
 * @param {number} [opts.quantity]  - Optional quantity for slab matching
 * @param {AbortSignal} [opts.signal] - Optional AbortSignal for cancellation
 * @returns {Promise<object>}       - Full API data payload
 */
export async function resolvePricing({ productId, partnerId, userId, quantity, signal } = {}) {
  const params = {
    productId,
    apiSource: 'partner',
    partnerId,
    userId,
  };

  if (quantity != null && Number.isFinite(Number(quantity)) && Number(quantity) > 0) {
    params.quantity = Number(quantity);
  }

  const response = await apiClient.get(ENDPOINT, { params, signal });
  const body = response?.data;
  if (body && typeof body === 'object' && 'data' in body) return body.data;
  return body;
}

const pricingResolveService = { resolvePricing };
export default pricingResolveService;
